import { APPS_CATALOG } from "../constants/appIntegration.config";
import type { AppConfig } from "../interfaces/appIntegration.interfaces";
import type { AppCategory } from "../types/appIntegration.types";

export const getAppsByCategory = (category: AppCategory, integrations: AppConfig[]): AppConfig[] => {
  return integrations.filter((app) => app.category === category);
};

export const getAvailableCategories = (integrations: AppConfig[]): AppCategory[] => {
  const categories = new Set(integrations.map((app) => app.category));
  return Array.from(categories) as AppCategory[];
};